export default __webpack_public_path__ + "static/media/progress-circle-done.a51aadf1.svg";